export enum CoachingSessionUserType {
  NONE = 'none',
  COACHEE = 'coachee',
  SHADOWER = 'shadower',
  COACH = 'coach',
  EDITOR = 'editor',
  CREATOR = 'creator',
}
